import { columns, row } from 'core/style';
import injectSheet, { createStyles } from 'core/style/injectSheet';
import { WithStyles, ITheme } from 'core/style/interfaces';
import { numEnding } from 'core/utils';
import React from 'react';

const styles = (theme: ITheme) =>
    createStyles({
        counter: {
            ...row(),
            marginLeft: 0,
            marginRight: 0,
            marginTop: 0.5 + 'rem',

            [theme.breakpoints.down('xs')]: {
                justifyContent: 'center',
            },
        },
        counter__digit: {
            ...columns,
            textAlign: 'center',
            width: 60,
        },
        counter__text: {
            marginBottom: 0,
            fontSize: '0.75rem',
            textTransform: 'uppercase',
        },
        counter__number: {
            fontSize: '1.6666667rem',
            fontWeight: 'bold',
            marginBottom: 10,
        },
        counter__divider: {
            fontSize: 1.25 + 'rem',
            fontWeight: 'bold',
            marginBottom: 0,
        },
    });

const addZeroIfNecessary = (value: number) => (value < 10 ? `0${value}` : value);

interface IProductDeadlineCounterProps {
    startDate: number;
}

interface IProductDeadlineCounterState {
    initialTime?: number;
}

class ProductDeadlineCounter extends React.Component<
    IProductDeadlineCounterProps & WithStyles<typeof styles>,
    IProductDeadlineCounterState
> {
    interval: number;

    constructor(props, context) {
        super(props, context);

        const nearestTime = this.props.startDate;

        this.state = {
            initialTime: nearestTime && nearestTime - new Date().getTime(),
        };
    }

    componentDidMount() {
        this.interval = window.setInterval(this.update, 1000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const nearestTime = nextProps.startDate;

        this.setState({
            initialTime: nearestTime && nearestTime - new Date().getTime(),
        });
    }

    update = () => {
        const { initialTime } = this.state;

        if (!initialTime || initialTime - 1000 <= 0) {
            const nextInitialTime = this.props.startDate;

            if (nextInitialTime) {
                this.setState({ initialTime: nextInitialTime - new Date().getTime() });
            } else {
                clearInterval(this.interval);
            }
        } else {
            this.setState({ initialTime: initialTime - 1000 });
        }
    };

    renderCounter(timeUntil: number) {
        const { classes } = this.props;
        const timeUntilInSeconds = timeUntil / 1000;
        const days = Math.floor(timeUntilInSeconds / 86400);
        const hours = Math.floor((timeUntilInSeconds % 86400) / 3600);
        const minutes = Math.floor(((timeUntilInSeconds % 86400) % 3600) / 60);
        const seconds = Math.trunc(timeUntilInSeconds % 60);

        return (
            <div className={classes.counter}>
                <div className={classes.counter__digit}>
                    <p className={classes.counter__number}>{days}</p>
                    <p className={classes.counter__text}>{numEnding(days, ['День', 'Дня', 'Дней'])}</p>
                </div>
                <p className={classes.counter__divider}>:</p>
                <div className={classes.counter__digit}>
                    <p className={classes.counter__number}>{addZeroIfNecessary(hours)}</p>
                    <p className={classes.counter__text}>{numEnding(hours, ['Час', 'Часа', 'Часов'])}</p>
                </div>
                <p className={classes.counter__divider}>:</p>
                <div className={classes.counter__digit}>
                    <p className={classes.counter__number}>{addZeroIfNecessary(minutes)}</p>
                    <p className={classes.counter__text}>{numEnding(minutes, ['Минута', 'Минуты', 'Минут'])}</p>
                </div>
                <p className={classes.counter__divider}>:</p>
                <div className={classes.counter__digit}>
                    <p className={classes.counter__number}>{addZeroIfNecessary(seconds)}</p>
                    <p className={classes.counter__text}>{numEnding(seconds, ['Секунда', 'Секунды', 'Секунд'])}</p>
                </div>
            </div>
        );
    }

    render() {
        return this.state.initialTime ? this.renderCounter(this.state.initialTime) : null;
    }
}

export default injectSheet(styles, 'ProductDeadlineCounter')(ProductDeadlineCounter) as React.ComponentType<
    IProductDeadlineCounterProps
>;
